import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

class Menu extends Component {
  static propTypes = {
    className: PropTypes.string,
    component: PropTypes.element,
    position: PropTypes.string,
    disabled: PropTypes.bool
  };
  static defaultProps = {
    className: '',
    position: 'right',
    disabled: false
  };
  state = {
    isVisible: false
  };
  componentWillUnmount() {
    window.removeEventListener('click', this.handleClose);
  }
  handleStop = e => {
    e.stopPropagation();
  };
  handleClose = e => {
    e.stopPropagation();
    window.removeEventListener('click', this.handleClose);
    this.setState({
      isVisible: false
    });
  };
  handleClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (this.props.disabled) return;
    this.setState(
      {
        isVisible: !this.state.isVisible
      },
      () => {
        if (this.state.isVisible) {
          window.addEventListener('click', this.handleClose);
        } else {
          window.removeEventListener('click', this.handleClose);
        }
      }
    );
  };
  render() {
    const { className, children, component, position, disabled } = this.props;
    const classList = classNames('menu', className, {
      'menu-disabled': disabled
    });
    const overlayClassList = classNames('menu-overlay', {
      'menu-overlay-visible': this.state.isVisible,
      'menu-overlay-left': position === 'left',
      'menu-overlay-right': position === 'right',
      'menu-overlay-center': position === 'center'
    });
    return (
      <div
        className={classList}
        onClick={this.handleClick}
        onMouseDown={this.handleStop}>
        {component ? (
          component
        ) : (
          <div className="menu-button fa fa-ellipsis-v" />
        )}
        <div className={overlayClassList}>{children}</div>
      </div>
    );
  }
}

export default Menu;
